import { AddDriverPanel } from "@/components/organisms";

export const AddDriver = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <AddDriverPanel />
    </div>
  );
};
